import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

export const messagingRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Messaging" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      { index: true, element: <Navigate replace to="conversations" /> },
      {
        path: "conversations",
        handle: { breadcrumb: "Conversations" },
        async lazy() {
          const { AdminMessagingConversationsPage } = await import(
            "./conversations-page"
          );
          return { Component: AdminMessagingConversationsPage };
        },
      },
      {
        path: "pre-purchase",
        handle: { breadcrumb: "Pre-Purchase Skills" },
        async lazy() {
          const { AdminPrePurchaseSkillsPage } = await import(
            "./pre-purchase-skills-page"
          );
          return { Component: AdminPrePurchaseSkillsPage };
        },
      },
      {
        path: "post-purchase",
        handle: { breadcrumb: "Post-Purchase Skills" },
        async lazy() {
          const { AdminPostPurchaseSkillsPage } = await import(
            "./post-purchase-skills-page"
          );
          return { Component: AdminPostPurchaseSkillsPage };
        },
      },
    ],
  },
];
